import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { Observable } from 'rxjs';
import { BaseDialogActionData, ButtonColor, CommonActionKey } from 'common';

@Component({
    selector: 'ifb-business-advisor-picker',
    templateUrl: './business-advisor-picker.component.html',
    styleUrls: ['./business-advisor-picker.component.scss'],
    standalone: false
})
export class BusinessAdvisorPickerComponent {
  actions: BaseDialogActionData[] = [
    { actionKey: CommonActionKey.Cancel, label: 'Cancel', buttonColor: ButtonColor.Default },
    { actionKey: CommonActionKey.Ok, label: 'Ok', buttonColor: ButtonColor.Primary },
  ];

  form: UntypedFormGroup;

  constructor(
    public dialogRef: MatDialogRef<BusinessAdvisorPickerComponent>,
    private formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any) {

    this.form = this.formBuilder.group({
      fullName: '',
    });
  }

  static show(dialog: MatDialog): Observable<any> {
    return dialog
      .open(BusinessAdvisorPickerComponent, {
        data: {},
        closeOnNavigation: true,
        width: "500px"
      })
      .afterClosed();
  }

  onActionClicked(actionData: BaseDialogActionData): void {
    if (actionData.actionKey === CommonActionKey.Ok) {
      this.dialogRef.close(this.form.get('fullName').value);
      return;
    }

    this.dialogRef.close();
  }
}
